import React from 'react'
import ResetPassword from 'src/containers/Auth/ResetPassword'

const ResetPasswordPage: React.FC = () => {
  return <ResetPassword></ResetPassword>
}

export const PATH = '/pwd/confirm' as const
export default ResetPasswordPage
